// Autogenerated file
export const feedbackTagFlagsEnum = {
    ForLogist: "ForLogist",
    ForDriver: "ForDriver",
    Positive: "Positive",
    Negative: "Negative",
};
export const feedbackTagFlags = [
    { label: "Для логиста", value: "ForLogist", intValue: 1 },
    { label: "Для водителя", value: "ForDriver", intValue: 2 },
    { label: "Положительный", value: "Positive", intValue: 4 },
    { label: "Отрицательный", value: "Negative", intValue: 8 },
];
